// DB Products
export const FETCH_PRODUCT_REQUEST = "FETCH_PRODUCT_REQUEST";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAIL = "FETCH_PRODUCT_FAIL";
export const SET_SELECTED_PRODUCT = "SET_SELECTED_PRODUCT";

export const FETCH_PRODUCTS_LIST_REQUEST = "FETCH_PRODUCTS_LIST_REQUEST";
export const FETCH_PRODUCTS_LIST_SUCCESS = "FETCH_PRODUCTS_LIST_SUCCESS";
export const FETCH_PRODUCTS_LIST_FAIL = "FETCH_PRODUCTS_LIST_FAIL";